import { useMutation } from "@tanstack/react-query";
import { UsersApi } from "@/openapi/generated";
import type { ResetPasswordFormSchema } from "@/schemas";

import { createOpenApiConfiguration } from "@/lib/utils";

interface IUseAuthResetPasswordProps {
  toast: ReturnType<typeof import("@/components/feedback").useToast>;
  uid: string;
  token: string;
}
export const useAuthResetPassword = ({
  toast,
  uid,
  token,
}: IUseAuthResetPasswordProps) => {
  const service = new UsersApi(createOpenApiConfiguration());

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async (data: ResetPasswordFormSchema) => {
      return service.apiUserAuthResetPasswordPost({
        resetPasswordRequest: {
          userId: uid,
          passwordResetToken: token,
          newPassword: data.newPassword,
        },
      });
    },
    onSuccess: () => {
      toast({
        title: "Success",
        description: "Your password has been reset successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    },
    onError: (error: any, variables) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to reset password";
      
      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    },
  });

  return { mutate, isPending, isError, isSuccess };
};
